
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

const ToastDefault = () => {
    return (
        <ToastContainer
            autoClose={1000}
            hideProgressBar={true}
            className="toast-chilling"
            position="top-center"
            newestOnTop={false}
            closeOnClick={true}
            rtl={false}
            pauseOnFocusLoss={false}
            draggable={false}
            pauseOnHover={false}
        />
    );
}

export default ToastDefault;